import React from "react";
import { ArrowRight, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { Button } from "@/components/ui/button";
export default function PrinceGeorgesHero() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [{
      "@type": "HomeAndConstructionBusiness",
      "name": "TriServe",
      "telephone": "855-435-6631",
      "areaServed": {
        "@type": "AdministrativeArea",
        "name": "Prince George's County, MD"
      }
    }, {
      "@type": "Service",
      "name": "Water Damage & Flood Restoration",
      "provider": {
        "@type": "HomeAndConstructionBusiness",
        "name": "TriServe"
      }
    }, {
      "@type": "Service",
      "name": "Sewage Backup Cleanup",
      "provider": {
        "@type": "HomeAndConstructionBusiness",
        "name": "TriServe"
      }
    }, {
      "@type": "Service",
      "name": "Fire & Smoke Damage Restoration",
      "provider": {
        "@type": "HomeAndConstructionBusiness",
        "name": "TriServe"
      }
    }, {
      "@type": "Service",
      "name": "Mold Remediation",
      "provider": {
        "@type": "HomeAndConstructionBusiness",
        "name": "TriServe"
      }
    }, {
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://triserveinc.com/"
      }, {
        "@type": "ListItem",
        "position": 2,
        "name": "Maryland",
        "item": "https://triserveinc.com/MarylandPage"
      }, {
        "@type": "ListItem",
        "position": 3,
        "name": "Prince George's County"
      }]
    }]
  };
  return <section id="princegeorgeshero" data-nav="light" className="relative overflow-hidden bg-background text-foreground py-16 sm:py-20 lg:py-24 border-b border-border">
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(jsonLd)
    }} />

      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <Breadcrumb className="mb-8">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">Home</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/MarylandPage">Maryland</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>Prince George's County</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <div className="space-y-6">
          <h1 className="text-3xl font-bold tracking-tight text-foreground sm:text-5xl lg:text-6xl font-default">
            Prince George's County Restoration Services by TriServe
          </h1>

          <p className="max-w-3xl text-lg sm:text-xl text-muted-foreground font-default leading-relaxed">
            24/7 rapid emergency response for water damage, sewage cleanup, fire recovery, and mold remediation throughout Prince George's County.
          </p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 pt-4">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-base font-semibold shadow-sm">
              <a href="tel:8554356631" className="inline-flex items-center justify-center gap-2">
                <Phone className="size-5" />
                <span>Call Now: 855-435-6631</span>
              </a>
            </Button>

            <Button asChild size="lg" variant="outline" className="border-border text-foreground hover:bg-muted text-base font-medium">
              <Link to="/ContactRequestServicePage" className="inline-flex items-center justify-center gap-2">
                <span>Request Service</span>
                <ArrowRight className="size-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}